export default "/_next/static/chunks/fonts/GraphikRegularItalic-a93334ccf002afcc27e539d3af3a27aa.otf";